import { DateStr, toDateRange } from '@mi-front/core';
import pick from 'lodash/pick';
import moment from 'moment';
import { apiClient } from '../../../../../../api';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { GlobalAudiosNoMatchesReportForm } from './form/form';
import { GlobalAudiosNoMatchesReportResult } from './result/GlobalAudiosNoMatchesReportResult';
import { GlobalAudiosNoMatchesReport } from './types';

type Props = Record<string, never>;

export function GlobalAudiosNoMatchesReportView(p: Props) {
  const resetValues = {
    ...toDateRange(moment().format('YYYY-MM-DD') as DateStr),
  };

  return (
    <ReportView<GlobalAudiosNoMatchesReport>
      defaultValues={resetValues}
      download={{
        filename: 'audios-no-matches-report',
      }}
      reportFn={(values, format) => {
        return apiClient.audit.reportGlobalNoMatches({
          audioRange: pick(values, 'from', 'to'),
          options: {
            format,
          },
        });
      }}
      Form={GlobalAudiosNoMatchesReportForm}
      Result={GlobalAudiosNoMatchesReportResult}
    />
  );
}
